// @flow
import { pickBy } from 'lodash';

import RemindAPI from 'lib/RemindAPI';
import GET_AUTO_MESSAGES_FOR_ORG_QUERY from 'admin/components/AdminAutoMessages/queries/GetAutoMessagesForOrg.gql';
import SAVE_AUTO_MESSAGE_MUTATION from 'admin/components/AdminNewAutoMessage/queries/SaveAutoMessageMutation.gql';
import SET_AUTO_MESSAGE_STATUS_MUTATION from 'admin/components/AdminNewAutoMessage/queries/SetAutoMessageStatusMutation.gql';
import ToastActions from 'actions/ToastActions';

export function setAutoMessageStatus(
  messageUuid: string,
  status: AutoMessageStatus,
  viewingOrgUuid: string,
  messageName: string,
  onChange?: () => void
) {
  const statusText = status === 'active' ? 'activated' : 'paused';
  RemindAPI.execute({
    mutation: SET_AUTO_MESSAGE_STATUS_MUTATION,
    variables: {
      input: {
        uuid: messageUuid,
        status,
      },
    },
    refetchQueries: [
      {
        query: GET_AUTO_MESSAGES_FOR_ORG_QUERY,
        variables: { organizationUUID: viewingOrgUuid },
      },
    ],
  }).then(
    () => {
      ToastActions.showSuccessToast(`${messageName} successfully ${statusText}`);
      if (onChange) {
        onChange();
      }
    },
    err => {
      console.warn(err);
      console.error(`AutoMessageActions - message unsuccessfully ${statusText}`);
      ToastActions.showErrorToast('Oops, looks like something went wrong');
    }
  );
}

export function duplicateAutoMessage(
  fieldsToDuplicate: *,
  viewingOrgUuid: string,
  redirect?: (uuid: string) => void
) {
  const messageContent = fieldsToDuplicate.messageContent && {
    body: fieldsToDuplicate.messageContent.body,
  };

  const sender = fieldsToDuplicate.sender && {
    uuid: fieldsToDuplicate.sender.uuid,
    type: fieldsToDuplicate.sender.__typename === 'EntitySender' ? 'district' : 'user',
  };

  const fullInput = {
    messageName: `Copy of ${fieldsToDuplicate.messageName}`,
    orgUuid: fieldsToDuplicate.orgUuid,
    includeParents: fieldsToDuplicate.includeParents,
    includeStudents: fieldsToDuplicate.includeStudents,
    messageContent,
    sender,
  };
  const filteredInput = pickBy(fullInput, field => field);

  RemindAPI.execute({
    mutation: SAVE_AUTO_MESSAGE_MUTATION,
    variables: {
      input: filteredInput,
    },
    refetchQueries: [
      {
        query: GET_AUTO_MESSAGES_FOR_ORG_QUERY,
        variables: { organizationUUID: viewingOrgUuid },
      },
    ],
  }).then(
    res => {
      ToastActions.showSuccessToast(
        `${fieldsToDuplicate.messageName || 'Message'} successfully duplicated`
      );
      if (redirect) {
        const messageUuid = res.saveAutoMessage.autoMessage.uuid;
        redirect(messageUuid);
      }
    },
    err => {
      console.warn(err);
      console.error('AutoMessageActions - error duplicating an auto message');
      ToastActions.showErrorToast('Oops, looks like something went wrong');
    }
  );
}
